// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NetworkMarkerPopup.module.scss */
.NetworkMarkerPopup_animated-popup__Iuext {
  transition: transform 0.4s ease-in-out;
}

.NetworkMarkerPopup_network-marker-popup-container__YVMbd {
  /* Your styles for the popup container div */
  background-color: #fff;
  padding: 15px; /* Add padding */
  border: 1px solid #ccc;
  border-radius: 4px;
  min-width: 100px; /* Minimum width */
  max-width: 200px; /* Maximum width */
  animation: NetworkMarkerPopup_breathe__YLkgL 2s ease-in-out infinite; /* Add breathing animation */
}

@keyframes NetworkMarkerPopup_breathe__YLkgL {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.01); /* Slightly larger size at 50% of the animation */
  }
  100% {
    transform: scale(1);
  }
}
.NetworkMarkerPopup_network-marker-name__UnCrk {
  /* Your styles for the name div */
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 5px; /* Add margin to create spacing */
}

.NetworkMarkerPopup_network-description-label__ku9M1 {
  /* Your styles for the description label */
  font-weight: bold;
  margin-top: 10px; /* Add margin to create spacing */
}

.NetworkMarkerPopup_network-marker-description__O2P6C {
  /* Your styles for the description div */
  font-size: 14px;
  max-height: 150px; /* Set maximum height */
  overflow-y: auto; /* Add vertical scrollbar if content overflows */
}

.NetworkMarkerPopup_clickable-icon__KhYWe {
  animation: NetworkMarkerPopup_glow__idXaB 800ms ease-in-out infinite alternate;
}

@keyframes NetworkMarkerPopup_glow__idXaB {
  0% {
    box-shadow: 0 0 5px 2px rgba(0, 123, 255, 0.5);
  }
  100% {
    box-shadow: 0 0 15px 6px rgba(0, 123, 255, 0.7);
  }
}
.NetworkMarkerPopup_marker-network-icon-mapview__2VXiF {
  /* Define the default icon size */
  width: 32px;
  height: 32px;
  transition: transform 0.5s ease !important; /* Add a transition for the transform property */
}
.NetworkMarkerPopup_marker-network-icon-mapview__2VXiF:hover {
  transform: scale(2) !important; /* Double the size on hover */
}`, "",{"version":3,"sources":["webpack://./src/Components/NetworkMarkerPopup/NetworkMarkerPopup.module.scss"],"names":[],"mappings":"AAAA,mCAAA;AAEA;EACE,sCAAA;AAAF;;AAGA;EACE,4CAAA;EACA,sBAAA;EACA,aAAA,EAAA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA,EAAA,kBAAA;EACA,gBAAA,EAAA,kBAAA;EACA,oEAAA,EAAA,4BAAA;AAAF;;AAGA;EACE;IACE,mBAAA;EAAF;EAEA;IACE,sBAAA,EAAA,iDAAA;EAAF;EAEA;IACE,mBAAA;EAAF;AACF;AAGA;EACE,iCAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA,EAAA,iCAAA;AADF;;AAIA;EACE,0CAAA;EACA,iBAAA;EACA,gBAAA,EAAA,iCAAA;AADF;;AAIA;EACE,wCAAA;EACA,eAAA;EACA,iBAAA,EAAA,uBAAA;EACA,gBAAA,EAAA,gDAAA;AADF;;AAIA;EACE,8EAAA;AADF;;AAIA;EACE;IACE,8CAAA;EADF;EAGA;IACE,+CAAA;EADF;AACF;AAKA;EACE,iCAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA,EAAA,gDAAA;AAHF;AAKE;EACE,8BAAA,EAAA,6BAAA;AAHJ","sourcesContent":["/* NetworkMarkerPopup.module.scss */\n\n.animated-popup {\n  transition: transform 0.4s ease-in-out;\n}\n\n.network-marker-popup-container {\n  /* Your styles for the popup container div */\n  background-color: #fff;\n  padding: 15px; /* Add padding */\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  min-width: 100px; /* Minimum width */\n  max-width: 200px; /* Maximum width */\n  animation: breathe 2s ease-in-out infinite; /* Add breathing animation */\n}\n\n@keyframes breathe {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.01); /* Slightly larger size at 50% of the animation */\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.network-marker-name {\n  /* Your styles for the name div */\n  font-weight: bold;\n  font-size: 16px;\n  margin-bottom: 5px; /* Add margin to create spacing */\n}\n\n.network-description-label {\n  /* Your styles for the description label */\n  font-weight: bold;\n  margin-top: 10px; /* Add margin to create spacing */\n}\n\n.network-marker-description {\n  /* Your styles for the description div */\n  font-size: 14px;\n  max-height: 150px; /* Set maximum height */\n  overflow-y: auto; /* Add vertical scrollbar if content overflows */\n}\n\n.clickable-icon {\n  animation: glow 800ms ease-in-out infinite alternate;\n}\n\n@keyframes glow {\n  0% {\n    box-shadow: 0 0 5px 2px rgba(0, 123, 255, 0.5);\n  }\n  100% {\n    box-shadow: 0 0 15px 6px rgba(0, 123, 255, 0.7);\n  }\n}\n\n\n.marker-network-icon-mapview {\n  /* Define the default icon size */\n  width: 32px;\n  height: 32px;\n  transition: transform 0.5s ease !important;  /* Add a transition for the transform property */\n\n  &:hover { \n    transform: scale(2) !important; /* Double the size on hover */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"animated-popup": `NetworkMarkerPopup_animated-popup__Iuext`,
	"network-marker-popup-container": `NetworkMarkerPopup_network-marker-popup-container__YVMbd`,
	"breathe": `NetworkMarkerPopup_breathe__YLkgL`,
	"network-marker-name": `NetworkMarkerPopup_network-marker-name__UnCrk`,
	"network-description-label": `NetworkMarkerPopup_network-description-label__ku9M1`,
	"network-marker-description": `NetworkMarkerPopup_network-marker-description__O2P6C`,
	"clickable-icon": `NetworkMarkerPopup_clickable-icon__KhYWe`,
	"glow": `NetworkMarkerPopup_glow__idXaB`,
	"marker-network-icon-mapview": `NetworkMarkerPopup_marker-network-icon-mapview__2VXiF`
};
export default ___CSS_LOADER_EXPORT___;
